import React from 'react';
import MainHeader from './MainHeader';
// import MiniHeader from './MiniHeader';
import Layout from './Layout';
import SupportTeam from './SupportTeam';
import GoToTop from './GoToTop';





export default function MainLayout({ children }) {
  return (
   
    <React.Fragment>
    <Layout>
    {/* <MiniHeader/> */}

      <MainHeader />
      {children}
      <SupportTeam/>
      <GoToTop/>
    </Layout>
  </React.Fragment>


  )
}
